<img [src]="fullLogo.src" [alt]="fullLogo.alt" />
